import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem, Paper, TextField } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../../redux/slice/user";
import api from "../../../API";
import { SearchBackDrop } from "../../component/common/SearchBackDrop";

interface UseCheckCntType {
  t_cnt: number;
  c_cnt: number;
  f_cnt: number;
}

const initailData_use_check: UseCheckCntType = {
  t_cnt: 0,
  c_cnt: 0,
  f_cnt: 0
};

export interface SwInsertType {
  site_name: string;
  title_sw: string;
  url: string;
  text_sw: string;
  issue_date: string;
  writer_sw: string;
  copyrighter_sw: string;
  orgext: string;
  data_type: string;
  topic_sw: string;
  keyword_sw: string;
  keyword2_sw: string;
}

const initailData: SwInsertType = {
  site_name: "",
  title_sw: "",
  url: "",
  text_sw: "",
  issue_date: "",
  writer_sw: "",
  copyrighter_sw: "",
  orgext: "",
  data_type: "",
  topic_sw: "",
  keyword_sw: "",
  keyword2_sw: "",
  
};

const TzaWorkerCreatePage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let manager_role = auth.user.roles.some((obj:any) => ['TZA'].includes(obj.role));

  const worker = auth.user.roles.filter((obj:any) => obj.role === 'TZA').map((info:any) => info.user_id)[0];   

  const [data, setData] = useState<SwInsertType>(initailData);

  // const [isp_mode , setIsp_mode] = useState<boolean>(manager_role);

  // const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)


  
  const [taskSelectPageOpen , setTaskSelectPageOpen] = useState<boolean>(false);
  const [task, setTask] = useState("01");

  const [work_yn, setWork_yn] = useState("모두");

  const [use_check, setUse_check] = useState("모두");

  const [workList, setWorkList] = useState([]);

  const [use_check_cnt, setUse_check_cnt] = useState<UseCheckCntType>(initailData_use_check);

  const [page, setPage] = useState(1);
  
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [backdrop, setBackdrop] = useState<boolean>(false)

  const saveSwData = async () => {

    const formData = new FormData();

    if(data.site_name == null || data.site_name == ""){
      alert('사이트명 - URL 을 입력하세요.')
      return;
    }

    if(data.title_sw == null || data.title_sw == ""){
      alert('텍스트 제목 을 입력하세요.')
      return;
    }

    if(data.url == null || data.url == ""){
      alert('출처 - URL 을 입력하세요.')
      return;
    }

    if(data.text_sw == null || data.text_sw == ""){
      alert('본문 내용 을 입력하세요.')
      return;
    }

    if(data.issue_date == null || data.issue_date == ""){
      alert('발행일자 를 입력하세요.')
      return;
    }

    if(data.writer_sw == null || data.writer_sw == ""){
      alert('저작자 를 입력하세요.')
      return;
    }

    if(data.copyrighter_sw == null || data.copyrighter_sw == ""){
      alert('저작권소유자 를 입력하세요.')
      return;
    }

    if(data.orgext == null || data.orgext == ""){
      alert('파일형태(원본) 를 입력하세요.')
      return;
    }

    if(data.data_type == null || data.data_type == ""){
      alert('자료유형(원본) 을 입력하세요.')
      return;
    }

    if(data.topic_sw == null || data.topic_sw == ""){
      alert('주제분류 를 입력하세요.')
      return;
    }

    // if(data.keyword_sw == null || data.keyword_sw == ""){
    //   alert('키워드 를 입력하세요.')
    //   return;
    // }

    formData.append("email", email);
    formData.append("worker", worker);
    formData.append("datas", JSON.stringify(data));
    
    setBackdrop(true)
    api.post("/sw-insert",formData)
    .then((res:any) => { alert("입력이 완료되었습니다."); setData(initailData); setBackdrop(false);})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})
    
  }

  const getAuth = async () => {
    if(!email){ nav('/') }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)); console.log('/@me',resp.data) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  useEffect(() => {
    getAuth()
  },[])

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      <Box sx={{margin:"20px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>데이터 정보</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">
        <Box>
          <Paper sx={{padding:"8px", margin:"16px", border:"3px solid #3e36a5", background: "linear-gradient(to right, #d5f0da 25%, #a3e4ed 75%)"}}>
              <Box sx={{width:"940px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>

                      <Box sx={{display:"flex", justifyContent: "center"}}>
                        <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/sw_flag.jpg'} />
                        <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>Kiswahili</Box>
                      </Box>
                    
                      {/* <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                      <Box><textarea value={data.keyword_sw} onChange={(e) => {setData({ ...data, keyword_sw: e.target.value });}} spellCheck="false" style={{width:"920px",minHeight:"22px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box> */}

                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                      <Box><textarea value={data.title_sw} onChange={(e) => {setData({ ...data, title_sw: e.target.value });}} spellCheck="false" style={{width:"920px",minHeight:"55px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                      <Box><textarea value={data.text_sw} onChange={(e) => {setData({ ...data, text_sw: e.target.value });}} spellCheck="false" style={{width:"920px",minHeight:"400px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                    </Box>
                  </Box>
                </Box>
              </Box>
          </Paper>
        </Box>

        <Box>
          <Paper sx={{padding:"20px", margin:"16px",position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >
              <Box display="flex" sx={{marginLeft: "8px"}}>
                <Box sx={{width:"100%"}}>
                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>작업워커</Box>
                    <Box sx={{fontSize:"14px", width:"190px"}}>{worker ? worker : "-"}</Box>
                  </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"114px"}}>사이트명</Box>
                    <Box sx={{fontSize:"14px", width:"500px"}}>
                      <TextField sx={{fontSize:"8px"}} id="site_name" name="site_name" size="small"
                                value={data.site_name} onChange={(e) => {setData({ ...data, site_name: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "500px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"114px"}}>출처 - URL</Box>
                    <Box sx={{fontSize:"14px", width:"500px"}}>
                      <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                                value={data.url} onChange={(e) => {setData({ ...data, url: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "500px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>
                  
                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>발행일자</Box>
                    <Box sx={{fontSize:"14px", width:"200px"}}>
                      <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small" type="date"
                                value={data.issue_date} onChange={(e) => {setData({ ...data, issue_date: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "200px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>
                  <Box sx={{border:"2px solid #a9a6c9"}}>
                    <Box display="flex" sx={{alignItems: "center", margin:"4px"}}>
                      {/* <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/sw_flag.jpg'} /> */}
                      <Box ml={1} sx={{fontSize:"14px",fontWeight:700, color:"#3e36a5"}}>스와힐리어(SW)</Box>
                    </Box>
                    <Box display="flex">
                      <Box m={1} display="flex" sx={{alignItems:"center"}}>
                        <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>저작자</Box>
                        <Box sx={{fontSize:"14px", width:"200px"}}>
                          <TextField sx={{fontSize:"8px"}} id="writer_sw" name="writer_sw" size="small"
                                    value={data.writer_sw} onChange={(e) => {setData({ ...data, writer_sw: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "200px", height:"30px", fontSize:"14px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                        <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>저작권소유자</Box>
                        <Box sx={{fontSize:"14px", width:"200px"}}>
                          <TextField sx={{fontSize:"8px"}} id="copyrighter_sw" name="copyrighter_sw" size="small"
                                    value={data.copyrighter_sw} onChange={(e) => {setData({ ...data, copyrighter_sw: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "200px", height:"30px", fontSize:"14px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <Box m={3} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>키워드</Box>
                      <Box sx={{fontSize:"14px", width:"500px"}}>
                        <TextField sx={{fontSize:"8px"}} id="keyword_sw" name="keyword_sw" size="small"
                                  value={data.keyword_sw} onChange={(e) => {setData({ ...data, keyword_sw: e.target.value });}}
                        // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                          InputProps={{
                            style: {width: "500px", height:"30px", fontSize:"14px"},
                            inputProps: { 
                              spellCheck: "false" // spellcheck를 false로 설정
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                  {/* <Box mt={2} display="flex">
                    <Box sx={{border:"2px solid #a9a6c9"}}>
                      <Box display="flex" sx={{alignItems: "center", margin:"4px"}}>
                        <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} />
                        <Box ml={1} sx={{fontSize:"14px",fontWeight:700, color:"#3e36a5"}}>한국어(KO)</Box>
                      </Box>
                      <Box m={1} display="flex" sx={{alignItems:"center"}}>
                        <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>저작자</Box>
                        <Box sx={{fontSize:"14px", width:"200px"}}>
                          <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small"
                                    value={data.copyrighter_ko} onChange={(e) => {setData({ ...data, copyrighter_sw: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "200px", height:"30px", fontSize:"14px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                        <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>저작자소유자</Box>
                        <Box sx={{fontSize:"14px", width:"200px"}}>
                          <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small"
                                    value={data.copyrighter_ko} onChange={(e) => {setData({ ...data, copyrighter_sw: e.target.value });}}
                          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                            InputProps={{
                              style: {width: "200px", height:"30px", fontSize:"14px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    </Box>

                  </Box> */}

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"106px"}}>주제분류</Box>
                    <Select id="topic_sw" value={data.topic_sw} onChange={(e) => {setData({ ...data, topic_sw: e.target.value });}} sx={{color:"green",width:"420px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                      <MenuItem dense value={"01"}>문화,예술,교육 (Utamaduni,Sanaa,Elimu)</MenuItem>
                      <MenuItem dense value={"02"}>역사,지리,관광 (Historia,Jiografia,Utalii)</MenuItem>
                      <MenuItem dense value={"03"}>스포츠,기타 (Nyingine,Michezo)</MenuItem>
                      <MenuItem dense value={"04"}>사회,산업 (Jamii,Viwanda)</MenuItem>
                      <MenuItem dense value={"05"}>정치,경제 (Siasa,Uchumi)</MenuItem>
                      <MenuItem dense value={"06"}>과학,의학 (Sayansi,Dawa)</MenuItem>
                      <MenuItem dense value={"07"}>관습,의례 (Desturi,Adabu)</MenuItem>
                      <MenuItem dense value={"08"}>일상생활,음식 (Maisha,Chakula)</MenuItem>
                    </Select>
                  </Box>

                  <Box display="flex">
                    <Box m={2} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"106px"}}>파일형태(원본)</Box>
                      <Box sx={{fontSize:"14px", width:"190px"}}>
                        <Select id="orgext" value={data.orgext} onChange={(e) => {setData({ ...data, orgext: e.target.value });}} sx={{color:"green",width:"130px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          <MenuItem dense value={"01"}>HTML</MenuItem>
                          <MenuItem dense value={"02"}>PDF</MenuItem>
                          <MenuItem dense value={"03"}>IMAGE</MenuItem>
                        </Select>
                      </Box>
                    </Box>

                    <Box m={2} ml={2} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>자료유형(원본)</Box>
                      <Box sx={{fontSize:"14px", width:"186px"}}>
                      <Select id="data_type" value={data.data_type} onChange={(e) => {setData({ ...data, data_type: e.target.value });}} sx={{color:"green",width:"130px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"01"}>저서</MenuItem>
                        <MenuItem dense value={"02"}>논문</MenuItem>
                        <MenuItem dense value={"03"}>기사</MenuItem>
                        <MenuItem dense value={"04"}>문서</MenuItem>
                        <MenuItem dense value={"05"}>직접작성</MenuItem>
                        <MenuItem dense value={"06"}>기타</MenuItem>
                      </Select>
                      </Box>
                    </Box>
                  </Box>

                  

                  

                  


                </Box>
              </Box>
          </Paper>
        </Box>
      </Box>


      
      
      <Box>
        

              <Box display="flex" justifyContent="center" sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
                <Box sx={{fontSize:"36px", paddingTop:"8px", color:"#60ad50", fontWeight:700,width:"100%"}}></Box>
              </Box>
              
            </Box>

        
      <Box display="flex" justifyContent="right" sx={{margin:"20px"}}>
      <Button variant="contained" color="warning" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            nav('/tza-worker');
          }}
        >
          뒤로
        </Button>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            saveSwData();
          }}
        >
          SAVE
        </Button>
      </Box>
     
      
    </Paper>
  );
};

export default TzaWorkerCreatePage;
